// extracted by mini-css-extract-plugin
export default {"homeContent__top":"c-i_cU","homeContent__bottom":"c-i_cV","homeContent__cardHolder":"c-i_cW","homeContent__seoTextHolder":"c-i_cX"};